import React, { useContext } from "react";
import { MapContext } from "./Map";
import classnames from "classnames";

export const VIEW_TYPES = [
  "ON",
  "OFF", // Only neighborhoods - here you can overlay population data
];

const getFullViewTypeName = (type) =>
  type === "ON"
    ? "By Neighborhood"
    : type === "OFF"
    ? "Individual Stories"
    : "";

// Ask Sam what to do with the isMobile
export const ViewSelector = ({ isMobile }) => {
  const { visibleViewType, setVisibleViewType, setInteractingWithMap } =
    useContext(MapContext);
  return (
    <div
      className={classnames(
        "view-selector",
        isMobile
          ? ""
          : "map-overlay maplibregl-ctrl maplibregl-ctrl-group ishidden-mobile"
      )}
      style={{ marginLeft: "5px" }}
    >
      <div className="field">
        <div className="control">
          <div style={{fontSize:"1em", fontWeight:"600"}}>View:</div>
          {VIEW_TYPES.map((viewType, i) => {
            const currentSelection = visibleViewType;
            return (
              <div key={i} className="radio">
                <label className="checkbox">
                  <input
                    type="radio"
                    name={`data-to-show${isMobile ? "-mobile" : ""}`}
                    checked={currentSelection === viewType}
                    onChange={() => {
                      setVisibleViewType(viewType);
                      setInteractingWithMap(true);
                    }}
                  />{" "}
                  {getFullViewTypeName(viewType)}
                </label>
              </div>
            );
          })}{" "}
        </div>
      </div>
    </div>
  );
};
